import {
  AvailabilityStatus,
  AvailabilityStatusType,
  CartItemResultFragment,
  ExternalStockLeadTime,
  ProductLifeCycleState,
  AvailabilityStatusPresentation,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { CartBaseProduct } from './cart-base-product-types'

export const getNormalizedCartProduct = (
  product: CartBaseProduct
): CartItemResultFragment['product'] => {
  return {
    displayName: product.displayName || '',
    displaySpecifications: product.displaySpecifications,
    manufacturerName: product.manufacturerName,
    manufacturerProductIdentifier: '',
    minQuantityPerOrder: 0,
    maxQuantityPerOrder: 0,
    nameSlug: product.nameSlug,
    productErpIdentifier: product.productErpIdentifier,
    primaryImageId: product.primaryImageId,
    nonReturnable: false,
    price: {
      originalPriceExcludingVat: product.price?.originalPriceExcludingVat || 0,
      originalPriceIncludingVat: product.price?.originalPriceIncludingVat || 0,
      formatted: { priceExcludingVat: '', priceIncludingVat: '' },
      priceExcludingVat: product.price?.priceExcludingVat || 0,
      priceIncludingVat: product.price?.priceIncludingVat || 0,
      //@ts-ignore
      __typename: 'Price',
    },
    requiredEndUserInformation: null,
    availability: {
      isAvailableForSale: product.availability?.isAvailableForSale || true,
      availabilityStatusPresentation:
        product.availability?.availabilityStatusPresentation ||
        AvailabilityStatusPresentation.ShowAsOutOfStock, // TODO: Needs a fallback value or else "Type 'AvailabilityStatusPresentation | undefined' is not assignable to type 'AvailabilityStatusPresentation'"
      isPreOrder: false,
      availabilityStatus: product.availability?.availabilityStatus || AvailabilityStatus.Unknown,
      productLifeCycleState:
        product.availability?.productLifeCycleState || ProductLifeCycleState.None,
      showAvailabilityQuantities: false,
      showEtaDate: false,
      availabilityDetails: product.availability?.availabilityDetails || {
        key: AvailabilityStatusType.ProductAvailabilityImmediateShipping,
        formattedDateUtc: '',
      },
      externalStock: {
        quantity: 0,
        leadTime: ExternalStockLeadTime.Always,
        ...product.availability?.externalStock,
      },
      internalStock: {
        quantity: 0,
        ...product.availability?.internalStock,
      },
      // @ts-ignore
      __typename: 'Availability',
    },
    __typename: 'Product',
  }
}
